// extracted by mini-css-extract-plugin
export default {"bymaMultiSelect":"BymaMultiSelect_bymaMultiSelect__FBuV1"};